import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/constants";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { FolderOpen, Link2, Check, Loader2 } from "lucide-react";

export default function LinkToCase({ itemId, itemType, title, summary, metadata, onLinked }) {
  const [cases, setCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState("");
  const [linking, setLinking] = useState(false);
  const [linked, setLinked] = useState(false);

  useEffect(() => {
    axios.get(`${API}/case-workspace/cases-summary`).then(r => setCases(r.data.data || [])).catch(() => {});
  }, []);

  const handleLink = async () => {
    if (!selectedCase || !itemId) return;
    setLinking(true);
    try {
      await axios.post(`${API}/case-workspace/cases/${selectedCase}/link`, {
        item_id: itemId,
        item_type: itemType,
        title,
        summary: summary || "",
        metadata: metadata || {},
      });
      setLinked(true);
      onLinked?.();
    } catch (err) {
      alert(err.response?.data?.detail || "Failed to link to case");
    } finally {
      setLinking(false);
    }
  };

  if (cases.length === 0) return null;

  if (linked) {
    return (
      <div className="flex items-center gap-2 p-3 bg-green-50 rounded-lg border border-green-200 text-sm text-green-700" data-testid="link-to-case-success">
        <Check className="w-4 h-4" />
        <span>Linked to case successfully</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 p-3 bg-slate-50 rounded-lg border" data-testid="link-to-case-panel">
      <FolderOpen className="w-4 h-4 text-slate-500 shrink-0" />
      <Select value={selectedCase} onValueChange={setSelectedCase}>
        <SelectTrigger className="h-8 flex-1 text-sm" data-testid="link-case-select">
          <SelectValue placeholder="Link to case..." />
        </SelectTrigger>
        <SelectContent>
          {cases.map(c => (
            <SelectItem key={c.id} value={c.id}>{c.case_title} ({c.stage})</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button size="sm" variant="outline" onClick={handleLink} disabled={!selectedCase || linking} className="h-8 shrink-0" data-testid="link-case-btn">
        {linking ? <Loader2 className="w-3 h-3 animate-spin" /> : <><Link2 className="w-3 h-3 mr-1" />Link</>}
      </Button>
    </div>
  );
}
